import React, { memo } from 'react';
import { Switch } from 'antd';

function OfficeSwitch({ checked, onChange, ...restProps }) {
  return (
    <div className="office-switch">
      LE Presence
      <Switch checked={checked} {...restProps} onChange={onChange} />
      Offices
    </div>
  );
}

export default memo(OfficeSwitch);
